/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        tabs: {
            height: {
                value: "40px",
                type: "dimension",
            },
            large: {
                height: {
                    value: "56px",
                    type: "dimension",
                },
                tab: {
                    fontSize: {
                        value: "1.125rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.5rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "fontWeight",
                    },
                },
            },
            tab: {
                paddingHorizontal: {
                    value: "16px",
                    type: "dimension",
                },
                color: {
                    value: "#455D82",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "fontWeight",
                },
                gap: {
                    value: "16px",
                    type: "dimension",
                },
                icon: {
                    color: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#94949429",
                        type: "color",
                    },
                    color: {
                        value: "#455D82",
                        type: "color",
                    },
                    icon: {
                        color: {
                            value: "#364262",
                            type: "color",
                        },
                    },
                },
                active: {
                    color: {
                        value: "#252C44",
                        type: "color",
                    },
                    icon: {
                        color: {
                            value: "#252C44",
                            type: "color",
                        },
                    },
                },
                focus: {
                    icon: {
                        color: {
                            value: "#252C44",
                            type: "color",
                        },
                    },
                },
                selected: {
                    color: {
                        value: "#252C44",
                        type: "color",
                    },
                    icon: {
                        color: {
                            value: "#252C44",
                            type: "color",
                        },
                    },
                    hover: {
                        color: {
                            value: "#252C44",
                            type: "color",
                        },
                    },
                    active: {
                        color: {
                            value: "#252C44",
                            type: "color",
                        },
                    },
                },
                disabled: {
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                    icon: {
                        color: {
                            value: "#b3b3b3",
                            type: "color",
                        },
                    },
                },
            },
            scrollButton: {
                width: {
                    value: "24px",
                    type: "dimension",
                },
                icon: {
                    color: {
                        value: "#1e1e1e",
                        type: "color",
                    },
                },
            },
            indicator: {
                height: {
                    value: "3px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#252C44",
                    type: "color",
                },
            },
            divider: {
                borderColor: {
                    value: "#455D82",
                    type: "color",
                },
                borderBottomWidth: {
                    value: "1px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
